import React, { createContext, useEffect, useMemo, useState } from "react";
import { returNombreRuta } from "../utils/funciones";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

export const DataContext = createContext();
export const ContextApi = ({ children }) => {
  const [reingresa, setReingresa] = useState(false);
  const [listaGuardado, setLista] = useState([]);
  const [visibleNotificaciones, setVisibleNotificaciones] = useState([]);
  const [nombreMenu, setNombreMenuu] = useState('');
  const [page, setPage] = useState(0);
  const [objTemporal, setObjTemporal] = useState([]);

  const [notificaciones, setNotificaciones] = useState([]);

  const location = useLocation();
  useEffect(() => { setNombreMenuu(returNombreRuta(location.pathname)); }, [location]);

  function setListaGuardado(item) { setLista([...listaGuardado, item]); }

  function setearPagina(item) { setPage(item); }

  const data = useMemo(() => ({
    reingresa, cambioReingresa: setReingresa,
    listaGuardado, setListaGuardado,
    page, setearPagina, nombreMenu,
    notificaciones, setNotificaciones,
    visibleNotificaciones, setVisibleNotificaciones,
    objTemporal, setObjTemporal
  }), [
    reingresa,
    listaGuardado,
    page,
    nombreMenu,
    notificaciones,
    visibleNotificaciones,
    objTemporal
  ]);

  return (<DataContext.Provider value={data}>{children}</DataContext.Provider>)
}

ContextApi.propTypes = {
  children: PropTypes.node.isRequired,
};